module.exports = __webpack_public_path__ + "static/media/sprite.7d87d30d.svg";